import React from 'react';
import { Link } from 'react-router-dom';

export default function TopHeader() {
  const toggleSidebar = () => {
    const sidebar = document.getElementById('sidebar');
    const overlay = document.getElementById('sidebarOverlay');
    const aside = document.getElementById('mainAside');

    if (window.innerWidth >= 992) {
      // Desktop: hide/show sidebar
      sidebar.classList.toggle('desktop-hidden');
      aside.classList.toggle('desktop-full');
    } else {
      // Mobile: slide in/out
      sidebar.classList.toggle('active');
      overlay.classList.toggle('active');
    }
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12 d-flex align-items-center justify-content-between bg-custom-header py-2 px-2 flex-wrap">

          {/* Left dots */}
          <div className="headerDots d-none d-md-flex gap-2">
            <i className="fa-solid fa-circle"></i>
            <i className="fa-solid fa-circle headerCenterDot"></i>
            <i className="fa-solid fa-circle"></i>
          </div>

          {/* Search */}
          <div className="search-wrapper my-2">
            <input type="text" placeholder="Accountingsystem / Dashboard" className="searchbar" />
            <div className="searchIconBox">
              <i className="fa-solid fa-search iconSearch"></i>
            </div>
          </div>

          {/* Right text */}
          <div className="headText d-none d-md-flex align-items-center gap-2">
            <Link to="/dashboard" className="d-flex align-items-center gap-2">
              <i className="bi bi-boxes iconRigthHead"></i>
              <span className="textRightHead me-2">Dashboard</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
